import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  selectConfiguration,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import GoalListPage from '../components/GoalListPage'
import {
  actionCreators,
  IGoalsListState,
  selectDueDate,
  selectError,
  selectFilterText,
  selectGoalType,
  selectIsLoading,
  selectItems,
  selectSortOrder,
  selectStatus,
  selectTotalItems,
} from '../modules/goalsList'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IGoalsListState & IGlobalConfigurationState
  >({
    configuration: selectConfiguration(),
    dueDate: selectDueDate(),
    error: selectError(),
    filterText: selectFilterText(),
    goalType: selectGoalType(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    sortOrder: selectSortOrder(),
    status: selectStatus(),
    totalItems: selectTotalItems(),
  }),
  actionCreators,
)(GoalListPage)
